export default {
  'pointCard.title': 'スタンプカード',
  'pointCard.welcome': '各種イベントに参加してスタンプを獲得しましょう',
  'pointCard.my_card': 'マイカード',
  'pointCard.all_events': 'すべてのイベント',
  'pointCard.event_period': 'イベント期間',
  'pointCard.exchange_period': '交換期間',
  'pointCard.exchange_period.no_limit': '交換期間 無期限',
  'pointCard.exchange_period.date': '交換期間 {date}',
  'pointCard.exchange_period.date_range': '交換期間 {start} ~ {end}',
  'pointCard.exchange_period.points_expired_in_this_month':
    '今月失効予定 {n} ポイント',
  'pointCard.exchange_period.points_expired_in_this_year':
    '今年失効予定 {n} ポイント',
  'pointCard.exchange_period.due_year': '{due}年間',
  'pointCard.exchange_period.due_month': '{due}か月間',
  'pointCard.exchange_period.due_day': '{due}日間',
  'pointCard.exchange_period.3': 'ポイント獲得後、次の {due} 年末まで有効',
  'pointCard.exchange_period.4': 'ポイント獲得後、{due}以内に交換可能',
  'pointCard.exchange_period.5':
    '最後にポイントを獲得した時点から有効期限を起算',
  'pointCard.exchange_period.6': '初回ポイント獲得時点から有効期限を起算',
  'pointCard.specified_store': '対象店舗',
  'pointCard.join': '参加',
  'pointCard.event_end': 'このイベントは終了しました',
  'pointCard.add_success': 'スタンプカードをマイカードに追加しました',
  'pointCard.event_deadline': 'イベント期限',
  'pointCard.detail': '詳細',
} as Record<string, string>;
